import { render, staticRenderFns } from "./PurchaseStats.vue?vue&type=template&id=1fc42f94&scoped=true"
import script from "./PurchaseStats.vue?vue&type=script&lang=js"
export * from "./PurchaseStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc42f94",
  null
  
)

export default component.exports